import React from 'react';
import { Shield, Crosshair, Brain, ShieldCheck } from 'lucide-react';

const SolutionsSection = () => {
  const solutions = [
    {
      icon: Shield,
      title: 'Infrastructure Inspection',
      description:
        'Autonomous robots that inspect pipelines, tunnels, and underground infrastructure without putting humans at risk.',
      tag: 'Vulcan',
    },
    {
      icon: Crosshair,
      title: 'Precision Field Measurement',
      description:
        'Tamper-proof digital measurement devices that replace traditional tools and output CAD-ready data directly.',
      tag: 'Astra',
    },
    {
      icon: Brain,
      title: 'AI-Powered Autonomy',
      description:
        'Machine learning navigation, sensor fusion, and edge computing that eliminate manual operation.',
      tag: 'Vulcan · Astra',
    },
    {
      icon: ShieldCheck,
      title: 'Data Integrity & Compliance',
      description:
        'Cryptographically signed measurements, real-time streaming, and audit-ready outputs for regulatory compliance.',
      tag: 'Vulcan · Astra',
    },
  ];

  return (
    <section id="solutions" className="py-24 px-6 relative overflow-hidden">
      <div
        className="absolute top-0 right-0 w-96 h-96 rounded-full blur-3xl opacity-10"
        style={{ background: '#F97316' }}
      />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground-primary">
            What We Offer
          </h2>
          <p className="text-lg max-w-2xl mx-auto text-foreground-secondary">
            Purpose-built technology solving real problems across critical industries
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-start">
          <div className="space-y-0">
            {solutions.map((solution, index) => (
              <div
                key={index}
                className="flex items-start gap-4 py-6 border-b last:border-b-0 group"
                className="border-subtle"
              >
                <solution.icon size={20} style={{ color: '#F97316', marginTop: '3px' }} className="flex-shrink-0" />
                <div>
                  <div className="flex items-center gap-3 mb-1">
                    <h3 className="text-lg font-semibold text-foreground-primary">
                      {solution.title}
                    </h3>
                    <span
                      className="text-[10px] font-semibold tracking-wide px-2 py-0.5 rounded-full"
                      style={{
                        background: 'rgba(249, 115, 22, 0.15)',
                        color: '#F97316',
                      }}
                    >
                      {solution.tag}
                    </span>
                  </div>
                  <p className="text-sm leading-relaxed text-foreground-secondary">
                    {solution.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="glass-frosted rounded-2xl overflow-hidden glow-subtle h-full">
            <img
              src="https://images.pexels.com/photos/16544054/pexels-photo-16544054.jpeg"
              alt="Industrial Solutions"
              className="w-full h-full object-cover min-h-[400px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
